let startAdsPos = -1;
let startTopHeaderScroll = 100;
let adsDiv = document.getElementById('ads');
let topHeader = document.querySelector('.top-header');

const stickySideAd = () =>
{
  if (!adsDiv)
    return;

  if (startAdsPos < 0)
    startAdsPos = findPosY(adsDiv) - 100;

  if (pageYOffset > startAdsPos )
  {
    adsDiv.style.position='sticky';
    adsDiv.style.top = '75px';
  }
  else
  {
    adsDiv.style.position = 'relative';
    adsDiv.style.top = 0;
  }
}

const stickyHeader = () =>
{
  if (!topHeader)
    return;

  if (pageYOffset > startTopHeaderScroll)
  {
    topHeader.style.position='fixed';
    topHeader.classList.add('compact');
    topHeader.style.top = 0;
  }
  else
  {
    topHeader.classList.remove('compact');
    topHeader.style.position='relative';
  }
}

const clickOutCloseMobileMenu = () =>
{
  document.addEventListener("click", (event) =>
  {
    let mobileMenuOpen = document.getElementById("mobile-menu").classList.contains("show");
    let outsideNavBar = !event.target.closest('.top-header');
    if (outsideNavBar && mobileMenuOpen) {
      document.getElementById("mobile-menu-btn").click();
    }
  });
}

const gmSearchForm = () =>
{
  let btnSearch = document.querySelector('.gm-search-form .btn-search');
  let form = document.querySelector('.gm-search-form');

  console.log(btnSearch);

  if (!btnSearch)
    return;

  btnSearch.addEventListener('click', (event) => {
    form.submit();
  })
}

window.onscroll = () =>
{
  stickySideAd();
  stickyHeader();
};

window.onload = () =>
{
  clickOutCloseMobileMenu();
  gmSearchForm();
}

function findPosY(obj)
{
  let curtop = 0;
  if (typeof (obj.offsetParent) != 'undefined' && obj.offsetParent)
  {
    while (obj.offsetParent)
    {
      curtop += obj.offsetTop;
      obj = obj.offsetParent;
    }
    curtop += obj.offsetTop;
  }
  else if (obj.y)
    curtop += obj.y;
  return curtop;
}


